import React, { Component } from 'react'
import { Rect, Oval } from 'react-flight/dom'

const AppBar = props => {
  return (
    <div
      style={{
        backgroundColor: '#E6ECF0',
        textAlign: 'left',
        width: 392,
        borderRadius: '6px 6px  0 0',
      }}
    >
      <div style={{ padding: 10 }}>
        <Oval
          size={12}
          style={{
            backgroundColor: '#95A2AA',
            display: 'inline-block',
            marginLeft: 3,
          }}
        />
        <Oval
          size={12}
          style={{
            backgroundColor: '#95A2AA',
            display: 'inline-block',
            marginLeft: 3,
          }}
        />
        <Oval
          size={12}
          style={{
            backgroundColor: '#95A2AA',
            display: 'inline-block',
            marginLeft: 3,
          }}
        />
      </div>
    </div>
  )
}

export default AppBar



// WEBPACK FOOTER //
// ./src/app-bar.js